module.exports = __webpack_public_path__ + "img/Infinite.160f5056.svg";